export default __webpack_public_path__ + "static/media/glm12500-300cap900x900.b0778261.png";